import { useQuery } from "@tanstack/react-query";
import { incentiveKeys } from "@/lib/query";
import { getJson } from "@/lib/time/api-client";
import type { IncentivesView } from "@/schemas/incentives";

/** The signed-in person's scorecard, every year (GET /api/incentives). Changes daily at most. */
export function useIncentives() {
  return useQuery({
    queryKey: incentiveKeys.mine(),
    queryFn: () => getJson<IncentivesView>("/api/incentives"),
    staleTime: 10 * 60_000,
  });
}
